import { FC, useState } from 'react'

import { B2bFormModal } from '@/screens/B2b/page/ui/B2bFormModal/B2bFormModal'

import { Button, ButtonProps, Modal } from '@/shared/ui'

import styles from './B2bFormButton.module.scss'

export type B2bFormButtonProps = ButtonProps & {
	big?: boolean
}

export const B2bFormButton: FC<B2bFormButtonProps> = ({ children, ...props }) => {
	const [isModalVisible, setIsModalVisible] = useState(false)

	const handleOpen = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation()
		if (props.onClick) {
			props.onClick(e)
		}
		setIsModalVisible(true)
	}

	const handleClose = () => {
		setIsModalVisible(false)
	}

	return (
		<>
			<Button type={props.type} className={styles.button} onClick={handleOpen}>
				{children}
			</Button>
			<Modal
				isOpen={isModalVisible}
				onClose={handleClose}
				className={styles.modal}
				contentClassName={styles.modalContent}>
				<B2bFormModal />
			</Modal>
		</>
	)
}
